module.exports = __webpack_public_path__ + "static/media/Happiness Can Make You Cry - Instrumental Version.fe9d1a49.jpg";